module.exports = __webpack_public_path__ + "static/img/enjoy3.3568032.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vip/enjoy3.png
// module id = F8Xw
// module chunks = 0